//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入省市区的的js文件
import City from "@/assets/js/area.js";
export default {
  props: ["controlItem"],
  data() {
    return {
      // 控制弹出框状态 show:true/fale
      show: false,
      //下拉城市值
      areaList: City,
      // 单机确定按钮获取的值
      cityname: "",
      // 城市
      SelectCityData: ""
    };
  },
  created() {
    this.SelectCityData = this.controlItem.ControlValue.join(" / ");
  },

  methods: {
    showPopup() {
      this.show = true;
    },
    back() {
      this.show = false;
    },
    // 单机地区选择取消按钮的操作
    showPicker() {
      this.show = false;
    },
    // 单机地区选择确认按钮的操作
    popupClose(el) {
      this.show = false;
      this.cityname = el;
      this.SelectCityData = "";
      var array = [];
      el.map(item => {
        array.push(item.name);
      });
      this.SelectCityData = array.join(" / ");
      this.controlItem.ControlValue = this.SelectCityData.split(" / ");
    }
  }
};
